import { createContext } from 'react';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './TradeOrderDetailTableProvider';
import { ILogo } from '@widgets/AccountLevelPositionsTable/lib/PositionsTableProvider/PositionsTableContext';

type DateRange = [string | null, string | null];

export interface ITradeOrderDetailTableContext {
    dateRange: DateRange;
    AssignPositionBody: any[];
    arrayWithLogos: ILogo[];
    portfolioLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    setOrderId: (value: any) => void;
}

export const TradeOrderDetailTableContext = createContext<ITradeOrderDetailTableContext>({
    dateRange: [null, null],
    AssignPositionBody: [],
    paginationOptions: null,
    portfolioLoading: false,
    arrayWithLogos: [],
    sortFieldName: '',
    desc: null,
    setOrderId: emptyFunc,
});
